import React from 'react';
import { ICurrency } from 'src/apis/common';
import { IMaDirectPlanTier } from 'src/apis/plans';
import PlanTier from './PlanTier';

export interface IProps {
  currency: ICurrency;
  tiers: IMaDirectPlanTier[];
}

const PlanTiers: React.FC<IProps> = ({currency, tiers}) => {
  return <>
    <h3>Tiers</h3>
    <div className={'plan-tiers'}>
      {tiers.map((tier, index) =>
        <PlanTier key={index} currency={currency} tier={tier}/>)}
    </div>
  </>
}

export default PlanTiers;
